
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'LVFUNCTION',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/LVFUNCTION.vue